module.exports = __webpack_public_path__ + "static/media/MrComplainInterior.55dc8a86.jpg";